(() => {
  const stringsNode = document.getElementById('SanearUxStrings');
  if (!stringsNode) return;
  const t = JSON.parse(stringsNode.textContent);
  const observed = new WeakSet();
  const wired = new WeakSet();
  let scheduled = false;
  const key = 'sanear.shipping.consultation';
  const read = () => { try { const value = JSON.parse(sessionStorage.getItem(key)); return value && Date.now() - value.time < 7200000 && /^[0-9]{8}$/.test(value.cep) ? value : null; } catch { return null; } };
  const save = (value) => { try { if (value) sessionStorage.setItem(key, JSON.stringify(value)); else sessionStorage.removeItem(key); } catch {} };
  const attr = (node, name, value) => { if (node && node.getAttribute(name) !== String(value)) node.setAttribute(name, String(value)); };
  const text = (node, value) => { if (node.textContent !== value) node.textContent = value; };
  const style = (root, id, css) => { if (!root.querySelector('#' + id)) { const el = document.createElement('style'); el.id = id; el.textContent = css; root.append(el); } };
  const format = cep => cep.slice(0, 5) + '-' + cep.slice(5);
  const schedule = () => { if (!scheduled) { scheduled = true; setTimeout(() => { scheduled = false; refresh(); }, 80); } };
  function observe(root) {
    if (observed.has(root)) return;
    observed.add(root);
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true, characterData: true, ...(root !== document ? { attributes: true, attributeFilter: ['aria-label', 'disabled', 'checked', 'value'] } : {}) });
  }
  function kit(root) {
    root.querySelectorAll('.cartmax-list-check').forEach(row => {
      const title = row.querySelector('cartmax-animo-title')?.textContent.trim();
      if (!title) return;
      const q = row.querySelector('cartmax-quantity')?.shadowRoot;
      if (q) {
        attr(q.querySelector('input[type="number"]'), 'aria-label', t.quantity + title);
        attr(q.querySelector('[name="minus"]'), 'aria-label', t.decrease + title);
        attr(q.querySelector('[name="plus"]'), 'aria-label', t.increase + title);
        style(q, 'sanear-kit-focus', 'button{min-width:40px;min-height:44px}input{min-height:44px;min-width:36px}button:focus-visible,input:focus-visible{outline:2px solid #004457;outline-offset:-2px}');
      }
      const check = row.querySelector('cartmax-checkbox')?.shadowRoot;
      if (check) {
        const input = check.querySelector('input');
        const mark = check.querySelector('.checkmark');
        if (!input || !mark) return;
        attr(input, 'aria-label', title);
        attr(mark, 'role', 'checkbox');
        attr(mark, 'aria-label', title);
        attr(mark, 'aria-checked', input.checked);
        attr(mark, 'aria-disabled', input.disabled);
        attr(mark, 'tabindex', input.disabled ? '-1' : '0');
        style(check, 'sanear-check-focus', '.checkmark:focus-visible{outline:2px solid #004457;outline-offset:3px}');
        if (!wired.has(mark)) {
          wired.add(mark);
          mark.addEventListener('keydown', event => { if ((event.key === ' ' || event.key === 'Enter') && !input.disabled) { event.preventDefault(); input.click(); schedule(); } });
        }
      }
    });
  }
  const purchaseForms = new Set();
  const purchaseVisibility = new Map();
  const purchaseObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => purchaseVisibility.set(entry.target, entry.isIntersecting));
    document.documentElement.classList.toggle('sanear-purchase-actions-visible', Array.from(purchaseVisibility.values()).some(Boolean));
  }, { threshold: 0 });
  function refresh() {
    document.querySelectorAll('.main-product-form, #checkout').forEach(node => {
      if (!purchaseForms.has(node)) { purchaseForms.add(node); purchaseObserver.observe(node); }
    });
    purchaseForms.forEach(node => {
      if (!node.isConnected) { purchaseObserver.unobserve(node); purchaseForms.delete(node); purchaseVisibility.delete(node); }
    });
    document.querySelectorAll('#calc-carrier li').forEach(row => {
      const name = row.querySelector('.ship-name');
      const date = name?.querySelector('span:last-child');
      if (name && date && /retir/i.test(name.textContent) && date.textContent.trim().toLowerCase() === 'hoje') {
        date.textContent = document.documentElement.lang.startsWith('pt') ? 'Confirme o prazo de preparação no checkout' : 'Confirm preparation time at checkout';
      }
    });
    attr(document.querySelector('#DrawerClose-Mobile-Nav'), 'aria-label', document.documentElement.lang.startsWith('pt') ? 'Fechar menu' : 'Close menu');
    document.querySelectorAll('.f-product__media-wrapper button[aria-label="Previous"]').forEach(button => attr(button, 'aria-label', document.documentElement.lang.startsWith('pt') ? 'Imagem anterior' : 'Previous image'));
    document.querySelectorAll('.f-product__media-wrapper button[aria-label="Next"]').forEach(button => attr(button, 'aria-label', document.documentElement.lang.startsWith('pt') ? 'Próxima imagem' : 'Next image'));
    document.querySelectorAll('#Drawer-MobileNav .sanear-nav-category').forEach((button, index) => {
      const content = button.parentElement.querySelector(':scope > [data-content]');
      if (!content) return;
      if (!content.id) content.id = 'sanear-mobile-category-' + index;
      attr(button, 'aria-controls', content.id);
    });
    const roots = [document];
    for (let i = 0; i < roots.length; i++) {
      const root = roots[i];
      observe(root);
      kit(root);
      root.querySelectorAll('*').forEach(node => { if (node.shadowRoot) roots.push(node.shadowRoot); });
    }
    document.querySelectorAll('[data-section-type="main-product"] .f-product-single__block--price').forEach(price => {
      if (price.querySelector('.sanear-purchase-jump')) return;
      const form = price.closest('[data-section-type="main-product"]')?.querySelector('.main-product-form');
      if (!form?.getAttribute('id')) return;
      const link = document.createElement('a');
      link.className = 'sanear-purchase-jump';
      link.href = '#' + form.getAttribute('id');
      link.textContent = t.options;
      link.addEventListener('click', () => { setTimeout(() => form.querySelector('[name="add"]')?.focus({ preventScroll: true }), 0); });
      price.append(link);
    });
    document.querySelectorAll('#formKokfyShipping').forEach(form => {
      const input = form.querySelector('input[name="cep"]');
      if (!input) return;
      attr(input, 'aria-label', 'CEP');
      attr(input, 'autocomplete', 'postal-code');
      let note = form.querySelector('.sanear-shipping-note');
      if (!note) {
        note = document.createElement('p'); note.className = 'sanear-shipping-note'; note.id = 'sanear-shipping-help'; form.append(note);
      }
      attr(input, 'aria-describedby', note.id);
      const saved = read();
      text(note, (saved ? t.consulted + format(saved.cep) + '. ' : '') + t.shipping);
      if (!wired.has(input)) {
        wired.add(input);
        if (!input.value && saved) input.value = format(saved.cep);
      }
    });
    document.querySelectorAll('calc-shipping-rate-block input[name="address[zip]"]').forEach(input => {
      if (!wired.has(input)) {
        wired.add(input);
        const saved = read();
        if (!input.value && saved) input.value = format(saved.cep);
      }
    });
    if (location.pathname.endsWith('/cart')) {
      const heading = document.querySelector('main h1');
      if (heading) {
        let note = document.querySelector('[data-sanear-cart-shipping]');
        if (!note) { note = document.createElement('p'); note.className = 'sanear-shipping-note'; note.setAttribute('data-sanear-cart-shipping', ''); heading.after(note); }
        const saved = read();
        text(note, (saved ? t.consulted + format(saved.cep) + '. ' : '') + t.shipping);
      }
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest?.('#formKokfyShipping .search_zipcode');
    if (!button) return;
    const input = button.closest('#formKokfyShipping')?.querySelector('input[name="cep"]');
    const cep = (input?.value || '').replace(/[^0-9]/g, '');
    save(cep.length === 8 ? { cep, time: Date.now() } : null);
    schedule();
  }, true);
  document.addEventListener('input', event => {
    if (!event.target.matches?.('#formKokfyShipping input[name="cep"]')) return;
    const cep = event.target.value.replace(/[^0-9]/g, '');
    if (cep !== read()?.cep) save(null);
    schedule();
  }, true);
  refresh();
  document.addEventListener('shopify:section:load', schedule);
})();
